exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".scroller[data-v-5eab3674]{max-height:380px;overflow:auto}", ""]);

// exports
